export enum WebEventName {
  UPDATE_DOWNLOAD_INFO = 'updateDownloadInfo',
}
